<template>
<div ref="otpCont" data-component="CodeInput.vue">
	<input
		v-for="(el, index) in digits"
		:key="el+index"
		v-model="digits[index]"
		type="tel"
		class="digit-box"
		:autofocus="index === 0"
		maxlength="1"
		:disabled="disabled"
		@keydown="handleKeyDown($event, index)"
		@paste="handlePaste($event)"
	>
</div>
</template>

<script>
export default {
	props: {
		digitCount: {
			type: Number,
			required: true,
		},
		autofocus: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
		},
	},
	emits: ['code-input-complete'],
	data() {
		return {
			digits: [],
		};
	},
	created() {
		for (let i = 0; i < this.digitCount; i++) {
			this.digits[i] = null;
		}
	},
	mounted() {
		if (this.focus) {
			(this.$refs.otpCont.children)[0].focus();
		}
	},
	methods: {
		handlePaste(event) {
			const code = event.clipboardData.getData('text');
			const codeArray = code.split('');
			if (code.length !== 4) {
				event.preventDefault();
			} else if (code.length === 4) {
				this.digits.forEach((el, index) => {
					this.digits[index] = codeArray[index];
				});
				this.$emit('code-input-complete', this.digits.join(''));
			}
		},
		isDigitsFull() {
			for (const elem of this.digits) {
				if (elem == null || elem === undefined) {
					return false;
				}
			}

			return true;
		},
		handleKeyDown(event, index) {
			if (event.key !== 'Tab' && event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
				event.preventDefault();
			}

			if (event.key === 'Backspace') {
				this.digits[index] = null;

				if (index !== 0) {
					(this.$refs.otpCont.children)[index - 1].focus();
				}

				return;
			}

			if ((new RegExp('^([0-9])$')).test(event.key)) {
				this.digits[index] = event.key;

				if (index !== this.digitCount - 1) {
					(this.$refs.otpCont.children[index + 1]).focus();
				}

				if (this.isDigitsFull()) {
					this.$emit('code-input-complete', this.digits.join(''));
				}
			}
		},
	},
};
</script>

<style scoped>
.digit-box {
    width: 44px;
    border-radius: 5px;
    margin: 5px;
    font-size: 16px;
    padding: 0;
    text-align: center;
}
</style>
